export default {
    data() {
        return {
            feature: [{
                title: '多场景模板',
                numberPic: require("../../assets/icons/num1.png"),
                text: '内置公开课听评、随堂听评、教研活动、会议纪要、教师讲义等专属模板，一键开启精准记录，自动归档。'
            }, {
                title: '实时语音转写',
                numberPic: require("../../assets/icons/num2.png"),
                text: '支持课堂、会议语音实时转文字，精准区分不同说话人，完整还原教学与研讨对话。'
            }, {
                title: 'AI 智能评课分析',
                numberPic: require("../../assets/icons/num3.png"),
                text: '依托 AI 能力自动生成专业的公开课听评课报告，从课堂整体概况、教学目标、课堂结构、教学亮点等多维度深度拆解教学内容。'
            }],
        }
    },
    created() {

    },
}